import { getAuthState } from "../../assets/scripts/login-util";
import { axiosGet, axiosPost } from "./axiosFunctions";

const loginUrl                                  = '/api/tpa/auth/login';
const logoutUrl                                 = '/api/tpa/auth/logout';

export const login = async (userName, password, remember, device) => {   
    const response = await axiosPost(loginUrl, {userName, password, remember, device}, { headers: ''});
    return response;
}

export const logout = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(()=> { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(logoutUrl, {
        headers: { auth_token: `bearer ${token}` }
    });
    return response;
}